<template>
  <div class='edicao' :style="{ backgroundImage: `url('${issue.cover}')` }">
    <v-container grid-list-md>
      <v-layout row wrap pt-4>
        <transition name='fade'>
          <v-flex
            xs12
            pl-4
            pr-4
            v-if='error === true'
            class='white--text text-center'
          >
            <v-alert :value='true' type='warning'>{{
                $t('text.IssueNotFound')
              }}
            </v-alert>
          </v-flex>
        </transition>

        <v-flex
          class='xs12 sm5 md4 pl-4 pr-4 text-xs-center'
          v-if='error === false'
        >
          <transition name='fade'>
            <img
              :src='issue.cover'
              v-if='issue.cover'
              alt
              class='edicao-cover'
            />
          </transition>
        </v-flex>

        <v-flex
          xs12
          sm7
          md8
          pl-4
          pr-4
          v-if='error === false && loaded === true'
          class='white--text'
        >
          <h1 class='headline mb-2'>{{ issue.title.name }}</h1>
          <div class='edicao-chips'>
            <span class='item'>{{ issue.title.publisher.name }}</span>
            <span class='item'>{{ issue.year }}</span>
            <span class='item'>Vol. {{ issue.volume }}</span>
            <span class='item'>{{ issue.pages }} {{ $t('text.pages') }}</span>
            <v-chip
              label outline color='white' nomargin
            >+{{ issue.title.age }}
            </v-chip
            >
          </div>

          <div class='seloRtl elevation-0 ml-2 mr-50 mt-4 mb-0' v-if='issue.isRtl'>
            <img src='@/assets/img/icon-rtl.png' />
            <span>{{ $t('text.readingRTL') }}</span>
          </div>

          <div class='ml-2 mr-0 mt-0 mb-0 bk '>
            <v-btn
              large
              color='btn-premium'
              :to="{ name: 'Subscription' }"
              class='elevation-0 ml-0 mr-0 mt-4 mb-4'
              v-if='issue.isFree === false && activeSubscription === false'
            >{{ $t('text.PremiumCustomerOnly') }}
            </v-btn
            >

            <v-btn
              large
              color='primary'
              :to="{
                name: 'EdicaoImage',
                params: {
                  issueId: $route.params.issueId,
                  type: 'image',
                  pageNumber: 0,
                },
              }"
              class='elevation-0 ml-0 mr-0 mt-4 mb-4'
              v-else-if="issue.type === 'image'"
              v-on:click="trackAnalytics('clicar-ler', 'read-comic')"
            >{{ $t('text.Read') }}
            </v-btn
            >

            <v-btn
              large
              color='primary'
              :to="{
                name: 'EdicaoVideo',
                params: {
                  issueId: $route.params.issueId,
                  type: 'video',
                  pageNumber: 0,
                },
              }"
              class='elevation-0 ml-0 mr-0 mt-4 mb-4'
              v-else
              v-on:click="trackAnalytics('clicar-ler', 'read-comic')"
            >{{ $t('text.Read') }}
            </v-btn
            >
            <br />

            <transition-group name='fade'>
              <v-btn
                key='btn-favorite'
                v-if='issue.title.name'
                flat
                color='white'
                v-bind:class="{ 'primary--text': issue.isFavorited }"
                class='ml-0 mr-0'
                :loading='sendingFavorite'
                @click.prevent='favorite'
                v-on:click='trackAnalyticsFavorite(issue.isFavorited)'
              >
                <v-icon left>turned_in_not</v-icon>
                <span v-if='issue.isFavorited === false'>{{
                    $t('text.addBookmark')
                  }}</span>
                <span v-if='issue.isFavorited'>{{ $t('text.Bookmarked') }}</span>
              </v-btn>

              <v-btn
                key='btn-share'
                v-if='issue.title.name'
                flat
                color='white'
                class='ml-0 mr-0'
                @click='share'
                target='_new'
                v-on:click="trackAnalytics('clicar-compartilhar', 'share-comic')"
              >
                <v-icon left>share</v-icon>
                {{ $t('text.Share') }}
              </v-btn>
            </transition-group>

            <transition name='fade'>
              <div
                v-html='issue.description'
                v-if='issue.description.length > 0'
                class='mt-4 mb-4'
              ></div>
            </transition>

            <transition name='fade'>
              <v-layout row wrap pt-4 v-if='authors.writer.length > 0'>
                <v-flex xs6 mb-3>
                  <b>{{ $t('text.WrittenBy') }}:</b>
                  <div>{{ arrayToNames(authors.writer) }}</div>
                </v-flex>

                <v-flex xs6 mb-3 v-if='authors.art.length > 0'>
                  <b>{{ $t('text.Art') }}:</b>
                  <div>{{ arrayToNames(authors.art) }}</div>
                </v-flex>

                <v-flex xs6 mb-3 v-if='authors.cover.length > 0'>
                  <b>{{ $t('text.Cover') }}:</b>

                  <div>{{ arrayToNames(authors.cover) }}</div>
                </v-flex>

                <v-flex xs6 mb-3>
                  <b>{{ $t('text.Genre') }}:</b>
                  <div>{{ arrayToNames(issue.title.categories) }}</div>
                </v-flex>

                <v-flex xs6 mb-3>
                  <b>{{ $t('text.PublishedBy') }}:</b>
                  <div>{{ issue.title.publisher.name }}</div>
                </v-flex>
              </v-layout>
            </transition>
          </div>
        </v-flex>
        <dialog-default
          :show='dialog.show'
          :title='dialog.title'
          :message='dialog.message'
          :ok='dialog.ok'
          v-on:close='dialogClose'
        ></dialog-default>
      </v-layout>
    </v-container>

    <v-dialog v-model='dialogShare' max-width='420px'>
      <v-card>
        <v-card-title>
          <b>{{ $t('text.Share') }}</b>
        </v-card-title>
        <v-card-text>
          <div class='copy-url'>
            <button
              type='button'
              v-clipboard:copy='pageShareUrl'
              v-clipboard:success='onCopy'
              v-clipboard:error='onError'
            >
              <span>{{ pageShareUrl }}</span>
              <v-icon color='primary'>file_copy</v-icon>
            </button>
          </div>

          <div class='share-icons'>
            <ShareNetwork
              network='whatsapp'
              title=''
              :url='pageShareUrl'
              :description='descShare'
            >
              <i class='fa fa-whatsapp'></i> Whatsapp
            </ShareNetwork>
            <ShareNetwork
              network='facebook'
              :url='pageShareUrl'
              :title='getTitle'
              :description='descShare'
              hashtags='SuperComics'
            >
              <i class='fa fa-facebook'></i> Facebook
            </ShareNetwork>
            <ShareNetwork
              network='telegram'
              :url='pageShareUrlTg'
              :title='getTitle'
              :description='descShare'
            >
              <i class='fa fa-telegram'></i> Telegram
            </ShareNetwork>
            <ShareNetwork
              network='sms'
              :url='pageShareUrl'
              :title='getTitle'
              :description='descShare'
            >
              <i class='fa fa-sms'></i> SMS
            </ShareNetwork>
            <ShareNetwork
              network='email'
              :url='pageShareUrl'
              :title='getTitle'
              :description='descShare'
            >
              <i class='fa fa-email'></i> Email
            </ShareNetwork>
            <ShareNetwork
              network='twitter'
              :url='pageShareUrl'
              :title='descShare'
            >
              <i class='fa fa-twitter'></i> Twitter
            </ShareNetwork>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-btn color='primary' flat @click.stop='dialogShare = false'>{{
              $t('text.Close')
            }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import bus from '@/utils/bus';
import DialogDefault from '@/components/dialog/Default';

export default {
  name: 'edicao',
  components: {
    'dialog-default': DialogDefault
  },
  metaInfo() {
    return {
      title: this.issue.title.name
        ? 'E-Komics - ' + this.issue.title.name
        : 'E-Komics'
    };
  },
  computed: {
    activeSubscription() {
      return this.$store.getters.activeSubscription;
    },
    pageURL() {
      return window.location.href;
    },
    pageShareUrl() {
      let urlBase = 'http://web-share.supercomics.com.br?';
      let title = this.issue.title.name;
      let image = this.issue.cover;
      let issue = this.$route.params.issueId;

      return (urlBase +=
        'title=' + encodeURIComponent(title) + '&image=' + encodeURIComponent(image) + '&issue=' + issue);
    },
    descShare() {
      return (
        'Olha essa Histórinha em Quadrinhos!?! Achei a sua cara, confere aqui no E-Komics: ' +
        this.issue.title.name
      );
    },
    getTitle() {
      return this.issue.title.name;
    },
    pageShareUrlTg() {
      let urlBase = 'http://web-share.supercomics.com.br?';
      let title = this.issue.title.name;
      let image = this.issue.cover;
      let issue = this.$route.params.issueId;

      return (urlBase +=
        'title=' + encodeURIComponent(title) + '&image=' + image + '&issue=' + issue + '&tg=true');
    }
  },
  data() {
    return {
      error: false,
      loaded: false,
      sendingFavorite: false,
      dialogShare: false,
      issue: {
        description: '',
        title: {
          name: '',
          publisher: {
            name: ''
          }
        }
      },
      authors: {
        art: [],
        writer: [],
        cover: []
      },
      dialog: {
        show: false,
        title: '',
        message: '',
        ok: () => {}
      }
    };
  },
  watch: {},
  mounted() {
    this.getEdicao();
  },
  methods: {
    arrayToNames(array) {
      if (array) {
        let arr = [];
        array.map((item) => {
          arr.push(item.name);
        });
        return arr.join(', ');
      }
    },
    trackAnalytics: function(p1, p2) {
      this.$ga.event('comic', p1, p2);
    },
    trackAnalyticsFavorite: function(isFavorite) {
      if (isFavorite) {
        this.$ga.event('comic', 'clicar-desfavoritar', 'unbookmark-comic');
      } else {
        this.$ga.event('comic', 'clilcar-favoritar', 'bookmark-comic');
      }
    },
    // eslint-disable-next-line no-unused-vars
    onCopy: function(e) {
      bus.$emit('snackbar', 'Link copied to clipboard.', 'success', 2500);
    },
    // eslint-disable-next-line no-unused-vars
    onError: function(e) {
      bus.$emit('snackbar', 'Failed to copy link.', 'error', 2500);
    },
    share() {
      this.dialogShare = true;

      setTimeout(() => {
        this.$refs.shareInput.focus();
      }, 400);
    },
    favorite() {
      this.sendingFavorite = true;

      axios
        .post('/issues/' + this.$route.params.issueId + '/favorite')
        .then(response => {
          if (response.data.favorite === 'added') {
            this.$set(this.issue, 'isFavorited', true);
            bus.$emit(
              'snackbar',
              this.$t('text.issueAddedToBookmark'),
              'primary',
              2000
            );
          } else if (response.data.favorite === 'removed') {
            this.issue.isFavorited = false;
            this.$set(this.issue, 'isFavorited', false);
            bus.$emit(
              'snackbar',
              this.$t('text.issueRemovedFromBookmark'),
              'brown',
              2000
            );
          }
          this.sendingFavorite = false;
          this.$store.commit('clearFavorites');
          this.$store.commit(
            'setSubscription',
            response.headers['active-subscription']
          );
        })
        .catch(() => {
          // console.error(e)
          bus.$emit(
            'snackbar',
            'Não é possível favoritar esta edição no momento.',
            'error',
            2500
          );
          this.sendingFavorite = false;
        });
    },
    getEdicao() {
      const isChild = localStorage.getItem('password') === null ? false : true;

      if (isChild) {
        axios
          .get(`/issues/child/${this.$route.params.issueId}`, {})
          .then((res) => {
            this.issue = res.data;
            this.issue.authors.map((elem) => {
              let item = {};
              item.name = elem.name;
              item.id = elem.id;

              if (elem.role === 'writer') {
                this.authors.writer.push(item);
              } else if (elem.role === 'art') {
                this.authors.art.push(item);
              } else if (elem.role === 'cover') {
                this.authors.cover.push(item);
              }
              bus.$emit('loading', false);
            });
            this.loaded = true;
          })
          .catch(e => {
            //console.warn(e);
            bus.$emit('loading', false);
            this.error = true;
            this.loaded = true;
            this.dialog = {
              show: true,
              title: this.$t('profile.ChildProfile'),
              message: e.response.data.message,
              ok: () => {
                this.dialog.show = false;
                this.$router.push('/');
              }
            };
            console.log('Dialog Object: ------>', this.dialog);
          });

      } else {
        axios
          .get(`/issues/${this.$route.params.issueId}`, {})
          .then((res) => {
            this.issue = res.data;
            this.issue.authors.map((elem) => {
              let item = {};
              item.name = elem.name;
              item.id = elem.id;

              if (elem.role === 'writer') {
                this.authors.writer.push(item);
                //this.$set(this.authors, 'writer', item)
              } else if (elem.role === 'art') {
                this.authors.art.push(item);
                //this.$set(this.authors, 'art', item)
              } else if (elem.role === 'cover') {
                this.authors.cover.push(item);
                //this.$set(this.authors, 'cover', item)
              }
              bus.$emit('loading', false);
            });
            this.loaded = true;
          })
          .catch((e) => {
            console.warn(e);
            bus.$emit('loading', false);
            this.error = true;
            this.loaded = true;
            this.dialog = {
              show: true,
              title: 'Erro',
              message: e.responseJSON.message,
              ok: () => {
                this.dialog.show = false;
              }
            };
          });
      }
    },
    dialogClose: function() {
      this.dialog.show = false;
    }
  }
};
</script>

<style lang='scss'>
@import '../assets/css/_variables';

.share-icons {
  span {
    display: inline-block;
    cursor: pointer;
    padding: 5px;
  }
;
  
  a {
    text-decoration: none;
    color: rgba(0, 0, 0, .87);
  }
}

.copy-url {
  position: relative;
  
  .input-url,
  input {
    max-width: calc(100% - 28px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  button {
    position: relative;
    top: 10px;
    right: 0;
    border-bottom: 2px solid $primary;
    width: 100%;
    text-align: left;
    margin-bottom: 22px;
    // line-height: 30px;
    cursor: text;
    
    span {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 92%;
      max-width: calc(100% - 25px);
      display: inline-block;
    }
    
    i {
      cursor: pointer;
      float: right;
    }
  }
}

.btn-premium {
  background-color: transparent !important;
  border-radius: 3px;
  border: 1px solid white;
  color: white !important;
}

.Edicao {
  main.v-content {
    height: 100%;
    background: $bar;
    
    & > .v-content__wrap {
      position: relative;
      
      // z-index: 1;
      &:before {
        content: '';
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        position: fixed;
        background-size: cover;
        opacity: 0.12;
      }
      
      &:after {
        content: '';
        left: 0;
        right: 0;
        bottom: -1000px;
        top: -1000px;
        position: fixed;
        // z-index: -1;
        background: -moz-linear-gradient(
            top,
            rgba(7, 11, 71, 0) 0%,
            rgba(7, 11, 71, 0) 1%,
            rgba(7, 11, 71, 1) 100%
        );
        background: -webkit-linear-gradient(
            top,
            rgba(7, 11, 71, 0) 0%,
            rgba(7, 11, 71, 0) 1%,
            rgba(7, 11, 71, 1) 100%
        );
        background: linear-gradient(
            to bottom,
            rgba(7, 11, 71, 0) 0%,
            rgba(7, 11, 71, 0) 1%,
            rgba(7, 11, 71, 1) 100%
        );
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00070b47', endColorstr='#070b47', GradientType=0);
      }
    }
  }
}

.edicao {
  height: 100%;
  background-size: cover;
  background-position: center 15%;
  background-attachment: fixed;
  
  &:before {
    content: '';
    left: 0;
    right: 0;
    bottom: -1000px;
    top: -1000px;
    position: fixed;
    z-index: 0;
    background: rgba(7, 11, 71, 0.85);
    // background: -moz-linear-gradient(top, rgba(7, 11, 71, 0) 0%, rgba(7, 11, 71, 0) 1%, rgba(7, 11, 71, 1) 100%);
    // background: -webkit-linear-gradient(top, rgba(7, 11, 71, 0) 0%, rgba(7, 11, 71, 0) 1%, rgba(7, 11, 71, 1) 100%);
    // background: linear-gradient(to bottom, rgba(7, 11, 71, 0) 0%, rgba(7, 11, 71, 0) 1%, rgba(7, 11, 71, 1) 100%);
  }
  
  .edicao-cover {
    @media only screen and (max-width: 599px) {
      max-width: 150px;
    }
  }
  
  div {
    z-index: 1;
  }
  
  &-cover {
    border-radius: 4px;
  }
  
  &-chips {
    font-size: 14px;
    
    .item {
      margin-right: 15px;
    }
    
    .v-chip {
      border-radius: 5px;
      font-size: 14px;
      top: -1px;
      
      .v-chip__content {
        height: 22px;
        padding: 0 8px;
      }
    }
  }
}

.bk {
  display: inline-block;
  float: none;
  width: 100%;
}

.seloRtl {
  div {
    display: inline-flex;
    margin: auto;
    justify-content: center;
    align-items: center;
  }
  
  img {
    display: inline-flex;
    float: left;
    width: 80px;
  }
  
  span {
    display: inline-flex;
    float: left;
    width: 180px;
    margin-left: 20px;
    font-size: 18px !important;
  }
}
</style>
